import { Injectable, inject, NgZone, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

const TIMEOUT_MS = 30 * 60 * 1000; // 30 minutos
const EVENTS = ['mousedown', 'keydown', 'touchstart', 'scroll'];

@Injectable({ providedIn: 'root' })
export class IdleTimeoutService implements OnDestroy {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly zone = inject(NgZone);

  private timer: ReturnType<typeof setTimeout> | null = null;
  private listening = false;

  start(): void {
    if (this.listening) return;
    this.listening = true;
    this.zone.runOutsideAngular(() => {
      EVENTS.forEach(e => document.addEventListener(e, this.reset, { passive: true }));
      this.scheduleLogout();
    });
  }

  stop(): void {
    this.listening = false;
    EVENTS.forEach(e => document.removeEventListener(e, this.reset));
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  ngOnDestroy(): void {
    this.stop();
  }

  private readonly reset = (): void => {
    if (this.timer) clearTimeout(this.timer);
    this.scheduleLogout();
  };

  private scheduleLogout(): void {
    this.timer = setTimeout(() => {
      this.zone.run(() => {
        this.auth.logout();
        this.router.navigateByUrl('/login?sessaoExpirada=1');
      });
    }, TIMEOUT_MS);
  }
}
